<template>
  <div>
    <loader v-show="$wait.is('osoblje')"></loader>
    <v-container v-show="!$wait.is('osoblje')">
      
      <v-tabs centered color="primary">
        <v-tab class="text-start">
          <svgicon
            class="ml-n4 pr-2"
            width="30"
            height="30"
            color="black black white black"
            icon="teacher"
          ></svgicon> <span>Akademsko
          <br />osoblje <span v-html="akademskoOsobljeTotal"></span></span>
        </v-tab>
        <v-tab class="justify-start">
          <svgicon class="pr-2" width="30" height="30" color="black white" icon="graduated"></svgicon> <span>Studenti <span v-html="studentiTotal"></span> </span>
        </v-tab>
        <v-tab class="justify-start">
          <svgicon class="pr-2" width="30" height="30" color="black white" icon="audience"></svgicon><span> Strani autori <span v-html="straniAutoriTotal"></span> </span>
        </v-tab>
        <v-tab-item>
          <uposlenici></uposlenici>
        </v-tab-item>
        <v-tab-item>
          <studenti></studenti>
        </v-tab-item>
        <v-tab-item>
          <strani-autori></strani-autori>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import "../assets/compiled-icons/graduated";
import "../assets/compiled-icons/teacher";
import "../assets/compiled-icons/audience";
import { mapGetters } from "vuex";
import { waitFor } from "vue-wait";


export default {
  name: "Home",
  metaInfo: {
      title: 'Autori - Registar radova'
    },
  computed: {
    ...mapGetters(["hasAdminRights", "getDeviceType","getStudenti", "getStraniAutori","getAkademskoOsoblje"]),
    akademskoOsobljeTotal(){
      return parseInt(this.getAkademskoOsoblje.total)? '('+parseInt(this.getAkademskoOsoblje.total)+')': ''
    },
    studentiTotal(){
      return parseInt(this.getStudenti.total)? '('+parseInt(this.getStudenti.total)+')':  ''
    },
    straniAutoriTotal(){
      return parseInt(this.getStraniAutori.total)? '('+parseInt(this.getStraniAutori.total)+')':  ''
    }
  },
  components: {

  },
  created() {
    waitFor("osoblje", async function () {
      await this.$store.dispatch("getAkademskoOsoblje", {
        item: 1,
        search: "",
      });
      await this.$store.dispatch("getStudenti", { item: 1, search: "" });
      await this.$store.dispatch("getStraniAutori", { page: 1, search: "" });
      await this.$store.dispatch("getZvanja", "");
      await this.$store.dispatch("getAkademskiStupnjevi", "");
    }).apply(this);
  }
};
</script>